// extracted by mini-css-extract-plugin
export default {"section":"index_section__B+8Jn","hidden":"index_hidden__bDNDE","contentWrapper":"index_contentWrapper__11pID","content":"index_content__qqrcM"};